<template>
    <loading ref="loading"></loading>
</template>

<script type="text/javascript">
import { getQueryString, fixSiteIndexURL } from '@/alias/utils';
import { getWebStatusReady } from '@/api/index';
import {setStorage, getStorage} from '@/alias/store'
import loading from "@/components/loading";

// import { getPinYinTranslation } from "@/api/index";


export default{
    name: 'landing',
    data(){
        return {
            infoData: {}
        }
    },
    components: {
        loading
    },
    methods: {
        // translateLastName: async function() {

        //     let param = { "text" : '中国' };
        //     let res = await getPinYinTranslation(param);
        //     console.log(res, 'res')
        // },
        getWebStatus: async function() {

            var code = getQueryString("code");
            fixSiteIndexURL();
            var param = { "code" : code };
            console.log( param, 'param')

            let res = await getWebStatusReady(param);
            console.log(res, 'data of getWebStatus')
            if(res.statusCode === 1) {
                console.log('is get userInfo')

                sessionStorage.setItem('userInfo', JSON.stringify(res.data));

                this.$router.replace({
                    path: '/SignIn',
                });
                console.log('oauth is end')

            }
            else if(res.statusCode === -1){
                console.log('not get userInfo')
                window.location.replace(res.redirectUrl);
            }
        }
    },
    mounted() {
        if(document.getElementById("loading").style.display === 'block') {
            this.$refs.loading.isLoading = false;
        } else {
            this.$refs.loading.isLoading = true;
        }
        if (!sessionStorage.getItem('userInfo')) {
            this.getWebStatus();
        } else {
            this.$router.replace({
                path: '/SignIn',
            });
        }
        // let data = {"subscribe":null,"openId":"o6pqU00-t6GV-6LJUSn9GKj-7MFA","nickname":"Yoooooooooooo!!!","sexDesc":"男","sex":1,"language":"zh_CN","city":"徐汇","province":"上海","country":"中国","headImgUrl":"http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJndWChWzHBGoFoOj9oM36IdkSgUG1yVLSK6j06HBRcq25EicXpSrvelNYAmbVKBzXcaSR9iaLdf5FA/132","subscribeTime":null,"unionId":"ov_Pr1LqWsbh-C2Mw95_ZM6ciFu8","remark":null,"groupId":null,"tagIds":null,"privileges":[]};
        // sessionStorage.setItem('userInfo', JSON.stringify(data));
        // this.translateLastName();

    }
}
</script>

<style scope lang="sass">
.test
    word-wrap: break-word;
</style>


// WEBPACK FOOTER //
// src/views/Landing.vue